(ns dre.processes.bootstrap
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.config :as conf]
   [dre.network :as-alias network]
   [dre.utils.fsm :as fsm]
   [dre.utils :as utils]
   [re-frame.core :as rf]
   [goog.string :as gstring]
   [goog.string.format]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))


(def db-path :app)


(def bs-fsm
  {nil {::init :ready}
   :ready {::check-auth :checking-auth}
   :checking-auth {::auth-ok :success
                   ::auth-nok :redirecting-to-sso}
   :redirecting-to-sso {::redirect-to-sso nil}})


;; -- Events

(rf/reg-event-fx
  ::init
  [(rf/path db-path)]
  (fn-traced
   [{db :db} [event opts]]
   {:db (fsm/update-next-state db event bs-fsm)
    :fx [[:dispatch [::check-auth opts]]]}))


(rf/reg-event-fx
  ::check-auth
  [(rf/path db-path)]
  (fn-traced
    [{db :db} [event opts]]
    {:db (fsm/update-next-state db event bs-fsm)
     ::network/request [{:endpoint :auth/check-auth}
                        {:request-content-type :text
                         :response-content-type :text
                         :on-success [::auth-ok opts]
                         :on-failure [::auth-nok]}]}))

(rf/reg-event-fx
 ::check-auth-periodical
 [(rf/path db-path)]
 (fn-traced
  [{db :db} [_]]
  {::network/request [{:endpoint :auth/check-auth}
                      {:request-content-type :text
                       :response-content-type :text
                       :on-success [::auth-ok-periodical]
                       :on-failure [::auth-nok]}]}))

(rf/reg-event-fx
 ::auth-ok-periodical
 [(rf/path db-path)]
 (fn-traced
  [{db :db} [_]]
  nil))

; TODO: this should be done on the backend or via subs!!!
(defn- normalize-user
  [user]
  (-> user
      (assoc :id (:docdata/user-id user))
      (assoc :name (str (:firstname user) " " (:lastname user)))))

(defn- normalize-source-labels
  [source-labels]
  (->> source-labels
       (map (fn [[k v]]
              [(->> k str rest (apply str)) v]))
       (into {})))

; TODO: we can also assoc stats in this step.
;       response contains :user-profile, :source-labels, :semgroup-label, :tags, :stats
(rf/reg-event-fx
  ::auth-ok
  []
  (fn-traced
    [{db :db} [event {:keys [::fetch-fx/response on-ok]}]]
    (let [app-db (get db db-path)
          user (-> response
                   (get-in [:body :config :user-profile])
                   normalize-user)
          user-base-url (get user :base-url)
          base-url (-> js/window
                       .-location
                       .-origin)]
      (if (or utils/localhost? (= base-url user-base-url))
        (let [source-labels (-> response
                                (get-in [:body :config :source-labels])
                                normalize-source-labels)
              email (get user :email "")
              global-config (-> (get-in response [:body :config])
                                (assoc :user user)
                                (assoc :config (get db :config))
                                (assoc :source-labels source-labels))
              platform-url (get-in global-config [:config :platform-url])
              _ (js/checkForDepartmentPrompt platform-url)
              _ (js/initUsersnap email (get-in response [:body :config :usersnap-token]))
              _ (set! conf/global-config global-config)]
          {:db (assoc db db-path (-> app-db
                                     (fsm/update-next-state event bs-fsm)
                                     (assoc :annotation (get-in response [:body :config :annotation]))
                                     (assoc :user user)
                                    ;;  (assoc :segment-writekey (get-in response [:body :config :segment-writekey]))
                                     (assoc :semgroup-label (get-in response [:body :config :semgroup-label]))
                                     (assoc :stats (get-in response [:body :config :stats]))))
           :dispatch on-ok})
        (let [return-path  (str (-> js/window
                                    .-location
                                    .-pathname)
                                (-> js/window
                                    .-location
                                    .-search))
              sso_url (gstring/format "%s%s" user-base-url return-path)]
          {:dispatch [::redirect-to-url sso_url]})))))


(rf/reg-event-fx
  ::auth-nok
  [(rf/path db-path)]
  (fn-traced
    [{db :db} [event]]
    {:db (fsm/update-next-state db event bs-fsm)
     :fx [[:dispatch [::redirect-to-sso]]]}))


(rf/reg-event-db
  ::redirect-to-sso
  (fn-traced
    [db [event]]
    (let [sso-url (conf/->sso-url db)]
      (fsm/update-next-state db event bs-fsm)
      (set! js/window.location.href sso-url))))

(rf/reg-event-db
 ::redirect-to-url
 (fn-traced
  [db [_ url]]
  (set! js/window.location.href url)))